import * as ResultsCustomOutput from './resultsCustomOutput.js';
export default ResultsCustomOutput;
